import React, { useEffect, useState } from "react";
import "./InvoiceList.scss";
import { Link } from "react-router-dom";
import { MdVisibility, MdPayment, MdEdit } from "react-icons/md";
import { adminRequest } from "../../../utils/requestMethods";

const InvoiceList = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  const [programs, setPrograms] = useState([]);
  const [students, setStudents] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalInvoices, setTotalInvoices] = useState(0);

  const limit = 10;

  const [filters, setFilters] = useState({
    course_id: "",
    student_id: "",
    status: "",
    semester: "",
  });

  const fetchPrograms = async () => {
    try {
      const response = await adminRequest.get("/course/getNameAndId");

      setPrograms(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchStudentsByCourse = async (courseId) => {
    try {
      const response = await adminRequest.post("/student/listByCourse", {
        id: courseId,
      });

      setStudents(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchInvoices = async (
    selectedFilters = filters,
    page = currentPage,
  ) => {
    try {
      setLoading(true);

      const queryParams = new URLSearchParams();

      if (selectedFilters.course_id) {
        queryParams.append("course_id", selectedFilters.course_id);
      }

      if (selectedFilters.student_id) {
        queryParams.append("student_id", selectedFilters.student_id);
      }

      queryParams.append("status", selectedFilters.status);
      queryParams.append("semester", selectedFilters.semester);
      queryParams.append("page", page);
      queryParams.append("limit", limit);

      const response = await adminRequest.get(
        `/invoice/list?${queryParams.toString()}`,
      );

      setInvoices(response.data.data);

      setCurrentPage(response.data.currentPage);

      setTotalPages(response.data.totalPages);

      setTotalInvoices(response.data.total);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchPrograms();
    fetchInvoices();
  }, []);

  const handleFilterChange = async (e) => {
    const updatedFilters = {
      ...filters,
      [e.target.name]: e.target.value,
    };

    if (e.target.name === "course_id") {
      updatedFilters.student_id = "";

      if (e.target.value) {
        await fetchStudentsByCourse(e.target.value);
      } else {
        setStudents([]);
      }
    }

    setFilters(updatedFilters);
    setCurrentPage(1);
    fetchInvoices(updatedFilters, 1);
  };
  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) {
      return;
    }

    fetchInvoices(filters, page);
  };

  return (
    <div className="invoiceListContainer">
      <div className="invoiceListHeader">
        <h2>Student Fee Invoices</h2>

        <Link to="/studentFees/create" className="createBtn">
          Create Invoice
        </Link>
      </div>

      <div className="filterSection">
        <div className="filterGroup">
          <label>Program</label>

          <select
            name="course_id"
            value={filters.course_id}
            onChange={handleFilterChange}
          >
            <option value="">All Programs</option>

            {programs.map((program) => (
              <option key={program.id} value={program.id}>
                {program.short_name}
              </option>
            ))}
          </select>
        </div>

        <div className="filterGroup">
          <label>Student</label>

          <select
            name="student_id"
            value={filters.student_id}
            onChange={handleFilterChange}
            disabled={!filters.course_id}
          >
            <option value="">All Students</option>

            {students.map((student) => (
              <option key={student.id} value={student.id}>
                {student.fullName}
              </option>
            ))}
          </select>
        </div>

        <div className="filterGroup">
          <label>Semester</label>

          <select
            name="semester"
            value={filters.semester}
            onChange={handleFilterChange}
          >
            <option value="">All Semesters</option>
            <option value="First Semester">First Semester</option>
            <option value="Second Semester">Second Semester</option>
            <option value="Third Semester">Third Semester</option>
            <option value="Fourth Semester">Fourth Semester</option>
            <option value="Fifth Semester">Fifth Semester</option>
            <option value="Sixth Semester">Sixth Semester</option>
            <option value="Seventh Semester">Seventh Semester</option>
            <option value="Eighth Semester">Eighth Semester</option>
          </select>
        </div>
        <div className="filterGroup">
          <label>Status</label>

          <select
            name="status"
            value={filters.status}
            onChange={handleFilterChange}
          >
            <option value="">All Statuses</option>

            <option value="DUE">Due</option>

            <option value="PAID">Paid</option>
            <option value="PARTIAL">Partial</option>

            <option value="FORWARDED">Forwarded</option>
          </select>
        </div>
      </div>

      <div className="invoiceTableWrapper">
        <table>
          <thead>
            <tr>
              <th>Invoice No</th>
              <th>Program</th>
              <th>Student</th>
              <th>Semester</th>
              <th>Total</th>
              <th>Paid</th>
              <th>Due</th>
              <th>Status</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="10" className="emptyState">
                  Loading invoices...
                </td>
              </tr>
            ) : invoices.length === 0 ? (
              <tr>
                <td colSpan="10" className="emptyState">
                  No invoices found
                </td>
              </tr>
            ) : (
              invoices.map((invoice) => (
                <tr key={invoice.id}>
                  <td>{invoice.invoice_number}</td>

                  <td>{invoice.Course?.short_name}</td>

                  <td>{invoice.Student?.fullName}</td>

                  <td>{invoice.semester}</td>

                  <td>Rs. {invoice.total_amount}</td>

                  <td>Rs. {invoice.paid_amount}</td>

                  <td>Rs. {invoice.due_amount}</td>

                  <td>
                    <span className={`status ${invoice.status.toLowerCase()}`}>
                      {invoice.status}
                    </span>
                  </td>

                  <td>{invoice.invoice_date}</td>

                  <td>
                    <div className="actionButtons">
                      <Link
                        to={`/studentFees/${invoice.uuid}`}
                        className="viewBtn"
                      >
                        <MdVisibility />
                      </Link>

                      <Link
                        to={`/studentFees/edit/${invoice.uuid}`}
                        className="editBtn"
                      >
                        <MdEdit />
                      </Link>

                      {invoice.status !== "PAID" &&
                        invoice.status !== "FORWARDED" && (
                          <Link
                            to={`/studentFees/payment/${invoice.uuid}`}
                            className="payBtn"
                          >
                            <MdPayment />
                          </Link>
                        )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <div className="paginationSection">
        <div className="paginationInfo">
          Total Invoices:
          <span>{totalInvoices}</span>
        </div>

        <div className="paginationButtons">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          <div className="pageNumber">
            {currentPage} / {totalPages}
          </div>

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default InvoiceList;
